 import WhatWeCard from './WhatWeCard';
 import WhatWeDoData from './WhatWeDoData';
 import SectionHeading from './SectionHeading';
 import './WhatWeDo.css';

const WhatWeDo = (props) => {
 return(

    // <!--What We Do-->
    <section className="what-we-do yk-discover" aria-labelledby="yk-discover-heading">
        {/* <div className="image-layer" style={{backgroundImage:url('https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/icons/featured-bg-pattern-2.png}}>
        </div> */}

        <div className="yk-discover-container">
            <SectionHeading 
                title="What We Are Doing"
                subtitle="Discover our spiritual programs and community initiatives"
            />

            <div className="yk-discover-grid">
                {/* <!--Service Block--> */}
               {/* <WhatWeCard
                imgicon='flaticon-therapy'
                Link="https://yugalkunj.org/words-of-wisdom.html"
                title="Words Of Wisdom"
                Desc="Words of Wisdom is inspirational message sent out by Didi Ji every Friday. To receive weekly emails of Words of Wisdom"
                 Readtext="Read More"
               /> */}
        



        {WhatWeDoData.map( (val, index) =>{

            
    return (


     
         <WhatWeCard 
          key={val.id}
          i_position={index + 1}
          i_feature_id={val.id}
          Link={val.Link}     
          title={val.title} 
                       
          Desc={val.Desc} 
         
          Readtext ={val.Readtext} 
        
       />
    );

  })}
                
              
               
            </div>
        </div>
    </section>

      


 )
   

 


}

export default WhatWeDo ;